/**
 * File Service Hooks
 * React hooks for accessing file management services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all file-related services
 */
export function useFileServices() {
    const { services } = useCCMS();
    if (!services?.file) {
        throw new Error('File services not available. Ensure CCMSProvider is configured with file services.');
    }
    return services.file;
}
/**
 * Hook to access FileService
 */
export function useFileService() {
    return useFileServices().file;
}
/**
 * Hook to access MultipartUploadService
 */
export function useMultipartUploadService() {
    return useFileServices().multipartUpload;
}
//# sourceMappingURL=useFileServices.js.map